import { render, staticRenderFns } from "./news.vue?vue&type=template&id=59dc2350&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=59dc2350&lang=scss&scoped=true&"
import style1 from "./news.vue?vue&type=style&index=1&id=59dc2350&scoped=true&lang=css&"
import style2 from "./news.vue?vue&type=style&index=2&id=59dc2350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc2350",
  null
  
)

export default component.exports